import logo from '../assets/logo- tusk up.svg';
import { Link } from 'react-router-dom';
export default function Logo() {
  return (
    <Link to='/'>
      <img src={logo} alt='logo' className='w-[65px] h-[46px] object-contain' />
    </Link>
  );
}
